module.exports = __webpack_public_path__ + "img/delete-bin.8809a593.svg";